import { gql } from "@apollo/client";

export const groupEnrollmentsByLinkId = gql`
  query groupEnrollmentsByLinkId(
    $scenarioId: ID!
    $originId: ID!
    $linkId: ID
    $filter: GroupsManagerEnrollmentsFilterInputType!
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      groupEnrollments(linkId: $linkId, filter: $filter) {
        items {
          isWaitingList
          group {
            code
            course {
              id
              code
              name
              curriculum {
                id
                code
                __typename
              }
              __typename
            }
            __typename
          }
          student {
            id
            code
            name
            firstName
            status
            meta
            __typename
          }
          term {
            id
            code
            name
            __typename
          }
          campus {
            id
            code
            name
            __typename
          }
          program {
            id
            code
            name
            department {
              id
              code
              __typename
            }
            modality {
              id
              code
              __typename
            }
            shift {
              id
              code
              name
              __typename
            }
            __typename
          }
          enrollmentDate
          __typename
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          page
          size
          total
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
